module.exports = __webpack_public_path__ + "static/img/home.fdc8799d.png";